import { AlertButton, AlertInput, AnimationBuilder, IonicSafeString } from "@ionic/angular";
import { TextFieldTypes } from "@ionic/core";
import { AlertOptions } from "@ionic/core";

export interface IButton {
  text: string;
  role: string;
  handler: (value: any) => boolean;
}

export interface IInput {
  name: string;
  type: TextFieldTypes;
  placeholder: string;
}

export class AlertModel implements AlertOptions {
  header: string = "";
  subHeader?: string;
  message?: string | IonicSafeString;
  cssClass?: string | string[];
  inputs?: AlertInput[];
  buttons?: (AlertButton | string)[];
  backdropDismiss?: boolean;
  translucent?: boolean;
  animated?: boolean;
  htmlAttributes?: { [key: string]: any };

  mode?: "ios" | "md";
  keyboardClose?: boolean;
  id?: string;

  enterAnimation?: AnimationBuilder;
  leaveAnimation?: AnimationBuilder;
}
